<template>
  <v-content class="pa-0">
    <v-card-title class="grey lighten-3">
      <v-row>
        <v-icon class="draggable">mdi-drag</v-icon>
        <v-col class="py-0">{{ translationLabel }}</v-col>
      </v-row>
    </v-card-title>
    <v-card-text class="pa-3">
      <v-container fluid grid-list-md class="pa-0">
        <v-layout v-if="context === 'newTranslation'" row wrap>
          <v-flex sm12>
            <v-text-field label="Label" v-model="t.label" :outlined="outlinedInputs"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm12>
            <v-text-field label="Translation" v-model="t.translation" :outlined="outlinedInputs"></v-text-field>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex sm12>
            <v-select
              label="Language"
              :items="languagesArray"
              v-model="languageId"
              item-text="node.name"
              item-value="node.id"
              :disabled="context != 'newTranslation'"
              :outlined="outlinedInputs"
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
    <v-card-actions class="grey lighten-4">
      <v-spacer></v-spacer>
      <v-btn color="warning" text @click="onClose">Cancel</v-btn>
      <v-btn color="primary" @click="saveTranslation" :disabled="disableSave">Save</v-btn>
    </v-card-actions>
    <div v-if="debug">{{t.label}}</div>
  </v-content>
</template>

<script>
import {
  ALL_LANGUAGES_SEARCH_QUERY,
  TRANSLATION_CREATE_MUTATION,
  TRANSLATION_UPDATE_MUTATION
} from "../../../../constants/graphql";

export default {
  name: "TranslationEditor",

  props: {
    translation: {
      type: Object,
      default: () => ({})
    },

    translationEditorDialog: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      t: {},
      languages: {},
      languagesArray: [],
      languageId: "",
      debug: false
    };
  },

  computed: {
    outlinedInputs() {
      return this.$store.getters.localSettings("outlinedInputs");
    },
    translationLabel() {
      return this.translation.label != null
        ? this.translation.label
        : "New Translation";
    },
    context() {
      if (this.translation.label == null) {
        return "newTranslation";
      }
      return this.translation.id != null ? "edit" : "create";
    },
    disableSave() {
      return this.t.label == null;
    }
  },

  methods: {
    saveTranslation() {
      let mutation =
        this.context == "edit"
          ? TRANSLATION_UPDATE_MUTATION
          : TRANSLATION_CREATE_MUTATION;
      this.$apollo
        .mutate({
          mutation: mutation,
          variables: {
            ...this.t,
            languageId: this.languageId
          }
        })
        .then(this.saveGqlObjectHandler, this.saveGqlObjectErrorHandler);
    },
    saveGqlObjectHandler(result) {
      this.$emit("saved", this.context);
    },
    saveGqlObjectErrorHandler(err) {
      console.log(err);
    },
    onClose() {
      this.$emit("closeDialog");
    }
  },

  watch: {
    translation(data) {
      if (data.language != null) {
        let translation = { ...data };
        delete translation.__typename;
        this.t = translation;
        this.languageId = translation.language.id;
      } else {
        this.t = {};
        this.languageId = "";
      }
    },
    translationEditorDialog(value) {
      if (!value) {
        this.t = {};
        this.languageId = "";
      }
    }
  },

  apollo: {
    languages: {
      query: ALL_LANGUAGES_SEARCH_QUERY,
      fetchPolicy: "network-only",
      result({ data, loader, networkStatus }) {
        this.languagesArray = data.languages.edges;
      }
    }
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/gt/admin/languages/TranslationEditor.vue